import React from "react";
import { Button, Typography, Box, SvgIcon } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { useTheme } from "@mui/material/styles";

import { useChainbridge } from "../../contexts/ChainbridgeContext/ChainbridgeContext";
import { BridgeConfig, EvmBridgeConfig } from "../../chainbridgeConfig";
import { boxClasses } from "../../utils/classes";
import { ReactComponent as SuccessTransfer } from "../../media/Icons/success.svg";
import { ReactComponent as ErrorTransfer } from "../../media/Icons/error.svg";
import { Button as FilledButton } from "../../components/Button";
import zIndex from "@mui/material/styles/zIndex";
interface ITransferActiveModalProps {
  open: boolean;
  close: () => void;
  handleClick: (blockExplorer: string, txHash: string) => void;
}

const TransferActiveModal: React.FC<ITransferActiveModalProps> = ({
  open,
  close,
  handleClick,
}: ITransferActiveModalProps) => {
  const {
    destinationAddress,
    transactionStatus,
    depositVotes,
    relayerThreshold,
    inTransitMessages,
    homeConfig,
    destinationChainConfig,
    depositAmount,
    transferTxHash,
    homeTransferTxHash,
    selectedToken,
    tokens,
  } = useChainbridge();
  const tokenSymbol = selectedToken && tokens[selectedToken]?.symbol;
  const theme = useTheme();
  const classes = {
    ...boxClasses,
    height: 300,
    overflow: "hidden",
    top: "auto",
    px: 0,
    pt: 0,
    borderRadius: `0 0 ${theme.spacing(5)} ${theme.spacing(5)}`,
  };

  return (
    <Box display="flex" flexDirection="column" sx={classes}>
      {/* <LinearProgress
        variant="determinate"
        color="secondary"
        value={transactionStatus !== "Transfer Completed" ? 1 : 100}
      /> */}
      <Box
        px={theme.spacing(7)}
        borderTop={`10px solid ${theme.palette.secondary.main}`}
        flex="1"
      >
        <Box
          display="flex"
          flexDirection="column"
          textAlign="center"
          height="100%"
        >
          <Typography variant="h3" component="h3" fontSize={24} mb={5} mt={5}>
            {transactionStatus === "Initializing Transfer" ? (
              "Initializing Transfer"
            ) : transactionStatus === "In Transit" ? (
              `In Transit (${
                depositVotes < (relayerThreshold || 0)
                  ? `${depositVotes}/${relayerThreshold} signatures needed`
                  : "Executing proposal"
              })`
            ) : transactionStatus === "Transfer Completed" ? (
              <Box display="flex" flexDirection="column" alignItems="center">
                <SvgIcon
                  component={SuccessTransfer}
                  inheritViewBox
                  sx={{ fontSize: 44 }}
                />

                <Typography variant="h5" mt={5}>
                  Transfer is done
                </Typography>
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center">
                <SvgIcon
                  component={ErrorTransfer}
                  inheritViewBox
                  sx={{ fontSize: 44 }}
                />

                <Typography variant="h5" mt={5}>
                  We couldn’t complete your transfer
                </Typography>
              </Box>
            )}
          </Typography>

          {transactionStatus === "Initializing Transfer" ? (
            <Box mb="30px">
              <Typography lineHeight="1.4375" mb="6px">
                Deposit pending...
              </Typography>
              <Typography lineHeight="1.4375">
                This will take a few minutes. Please do not refresh or leave the
                page.
              </Typography>
            </Box>
          ) : transactionStatus === "In Transit" ? (
            <Box display="flex" flexDirection="column" flex="1">
              <Box mb="30px">
                {/* inTransitMessages.map((m, i) => {
                  if (typeof m === "string") {
                    return (
                      <Typography
                        component="p"
                        key={i}
                        lineHeight="1.4375"
                        mb="6px"
                      >
                        {m}
                      </Typography>
                    );
                  } else if (typeof m === "object" && m.message !== undefined) {
                    return (
                      <Typography component="p" key={i} lineHeight="1.4375">
                        {m.message}
                      </Typography>
                    );
                  } else {
                    return (
                      <Typography component="p" key={i} lineHeight="1.4375">
                        <span>Vote casted by {m.address}</span>
                        <br />
                        <span>{m.signed}</span>
                      </Typography>
                    );
                  }
                }) */}
                <Typography lineHeight="1.4375">
                  This should take a few minutes. <br />
                  Please do not refresh or leave the page.
                </Typography>
              </Box>
              <Box marginTop="auto">
                <FilledButton
                  onClick={() => {
                    homeConfig &&
                      homeConfig.blockExplorer &&
                      homeTransferTxHash &&
                      handleClick(homeConfig.blockExplorer, homeTransferTxHash!);
                  }}
                  // disabled={
                  //   !destinationChain ||
                  //   !destinationChain.blockExplorer ||
                  //   !transferTxHash
                  // }
                >
                  View transaction
                </FilledButton>
              </Box>
            </Box>
          ) : transactionStatus === "Transfer Completed" ? (
            <>
              <Box marginTop="auto">
                <FilledButton
                  onClick={() => {
                    // homeConfig &&
                    //   homeConfig.blockExplorer &&
                    //   homeTransferTxHash &&
                    //   handleClick(homeTransferTxHash!);
                    destinationChainConfig &&
                      destinationChainConfig.blockExplorerAccount &&
                      destinationAddress &&
                      handleClick(destinationChainConfig.blockExplorerAccount, destinationAddress);
                  }}
                  // disabled={
                  //   !destinationChain ||
                  //   !destinationChain.blockExplorer ||
                  //   !transferTxHash
                  // }
                >
                  View Account
                </FilledButton>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body1" mb={8} lineHeight="1.4375">
                Something went wrong.
              </Typography>
              {homeConfig &&
                homeConfig.blockExplorer &&
                homeTransferTxHash && (
                  <FilledButton
                    onClick={() =>
                      window.open(
                        `${
                          homeConfig.blockExplorer
                        }/${transferTxHash}`,
                        "_blank",
                      )
                    }
                    disabled
                  >
                    View transaction
                  </FilledButton>
                )}
              <FilledButton onClick={close}>Start new transfer</FilledButton>
              {/* TODO: why do we need this? This link does not visible */}
              <Box display="none">
                <a
                  rel="noopener noreferrer"
                  href={process.env.REACT_APP_SUPPORT_URL}
                  target="_blank"
                >
                  <Button>
                    Ask a question on {process.env.REACT_APP_SUPPORT_SERVICE}
                  </Button>
                </a>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TransferActiveModal;
